/** @jsxImportSource @emotion/react */
/* eslint-disable no-nested-ternary */
import { string, bool, func } from 'prop-types';
import { ButtonStyled, TextStyled } from '@nike/nike-design-system-components';
import { Close } from '@nike/nike-design-system-icons';
import { keyframes } from '@emotion/react';

import { TranslatedCopy } from '../intl/TranslatedCopy';

const ellipsisKeyFrame = keyframes`
  to {
    width: 1.25em;    
  }
`;

export const DownloadBanner = ({ title, isLoading, hasError, closeBanner }) => {
  return (
    <div
      data-testid='downloadBanner'
      css={{
        position: 'fixed',
        display: 'flex',
        top: 0,
        zIndex: 99999,
        background: 'black',
        borderBottom: '1px solid grey',
        transition: 'padding 0.3s',
        width: '100%',
        padding: '16px 0'
      }}
    >
      <TextStyled
        appearance='title4'
        color={hasError ? 'error' : 'primaryInverse'}
        css={{
          flex: 2,
          paddingLeft: '20px'
        }}
      >
        {title}{' '}
        {isLoading ? (
          <>
            <TranslatedCopy id='downloads.status.downloading' />
            <span
              css={{
                animation: `${ellipsisKeyFrame} steps(4, end) 2s infinite`,
                overflow: 'hidden',
                display: 'inline-block',
                verticalAlign: 'bottom',
                width: '0px',
                color: 'white'
              }}
            >
              ...
            </span>
          </>
        ) : hasError ? (
          <TranslatedCopy id='downloads.status.error' />
        ) : (
          <TranslatedCopy id='downloads.status.complete' />
        )}
      </TextStyled>
      <ButtonStyled
        appearance='text'
        background='dark'
        ariaLabel={new TranslatedCopy({ id: 'downloads.dismiss' }).toString()}
        type='button'
        onClick={closeBanner}
        css={{
          paddingRight: '20px'
        }}
      >
        <TranslatedCopy id='downloads.dismiss' />
        <Close size='s' css={{ marginLeft: '5px' }} />
      </ButtonStyled>
    </div>
  );
};

DownloadBanner.propTypes = {
  title: string.isRequired,
  isLoading: bool,
  hasError: bool,
  closeBanner: func.isRequired
};

DownloadBanner.defaultProps = {
  isLoading: false,
  hasError: false
};
